import { useSelector } from "react-redux";

import { useActions } from "./useActions";
import { requestLoadComponentsPreloader } from "../redux/home-insurance/home-insurance.actions";

export default function usePreloadComponents() {
    const actions = useActions({ requestLoadComponentsPreloader });
    const { isLoadRequested } = useSelector(
        state => state.HomeInsurance.lazyComponents.preloadComponents
    );
    return {
        isLoadRequested: isLoadRequested,
        requestLoadComponentsPreloader: actions.requestLoadComponentsPreloader,
    };
}
